import type {RouteRecordRaw, RouteLocationRaw} from "vue-router";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";

export function getAfterSignUpRouteRecord():RouteRecordRaw{
  return {
    name: 'after_sign_up',
    path: '/check-your-mail',
    component: customAsyncComponent(async () => import('./views/AfterSignUpView.vue')),
    meta: {
      noAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.AFTER_SIGN_UP,
      ],
    },
  }
}

export function getAfterSignUpRouteLocation():RouteLocationRaw{
  return { name: 'after_sign_up' }
}